
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var isBrowser = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var isBrowser$1 = isBrowser;

export { isBrowser$1 as default };
//# sourceMappingURL=isBrowser.js.map
